<template>
  <div class="gift-box">
    <el-form inline style="margin: 5px 0;" :model="searchForm" class="gift-search-box">
      <el-row>
        <el-col :span="20">
          <el-form-item label="综合查询">
            <el-input
              style="width: 300px; margin-right: 10px"
              v-model.trim="searchForm.keyWords"
              clearable
              placeholder="产品名称&供应商名称"
              @keyup.13.native="onSearch"
            />
          </el-form-item>
          <el-form-item label="价格区间">
            <span class="price-box">
              <CustomNumInput
                :value="searchForm.minPrice"
                :maxlength="999999999"
                :limitNum="0"
                @change-emit="val => (searchForm.minPrice = val)"
              />
              <i>-</i>
              <CustomNumInput
                :value="searchForm.maxPrice"
                :maxlength="999999999"
                :limitNum="0"
                @change-emit="val => (searchForm.maxPrice = val)"
              />
            </span>
          </el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button type="primary" @click="onReset">清空</el-button>
        </el-col>
        <el-col :span="4">
          <el-link
            style="float: right;"
            type="primary"
            href="https://syounggroup.feishu.cn/sheets/Bl7zs2D31hmc5KtvihPclzGvnLb"
            target="_blank"
          ><i class="el-icon-s-promotion" style="margin-right: 4px;"></i>物料自采供应商库</el-link>
        </el-col>
      </el-row>
    </el-form>
    <div class="tips-jump">
      如您没有找到合适的产品，请
      <el-button type="text" @click="goWishList">填写心愿单</el-button>
      ，提交您的心愿需求
      <i class="iconfont icon-aixin" style="color: #ab0033; font-size: 13px"></i>
    </div>
    <SearchType
      ref="SearchType"
      class="search-Type"
      @change-list="changeList"
    />
    <CommonTable
      ref="CommonTable"
      :loading="tableLoading"
      :tableHead="tableHead"
      :tableData="tableData"
      :tableParam="tableParam"
      :showCheckbox="false"
      @page-size-change="pageSizeChange"
      @sort-change="sortChange"
    >
      <template #mainImage="{ row }">
        <el-image
          style="width: 50px; height: 50px;"
          :src="row.mainImage + $ImgQuality30"
          :preview-src-list="[row.mainImage + $ImgPreviewQuality]"
          fit="contain"
        >
          <div slot="placeholder" class="sample-image-slot">
            加载中
          </div>
        </el-image>
      </template>
      <template #productName="{ row }">
        <el-button type="text" @click="getDetail(row)">{{ row.productName }}</el-button>
      </template>
    </CommonTable>
  </div>
</template>
<script>
import SearchType from './SearchType';
import CommonTable from '@/components/CommonTable';
import CustomNumInput from '@/components/CustomNumInput';

export default {
  name: 'sample-gift',
  components: { SearchType, CommonTable, CustomNumInput },
  props: {},
  data() {
    return {
      name: "GIFT",
      searchVal: '',
      tableParam: {
        pageNo: 1,
        pageSize: 10,
        data: {},
      },
      searchForm: {
        firstCategory: 'MATERIAL',
        secondCategory: '',
        keyWords: '',
        minPrice: '',
        maxPrice: '',
        productType: ''
      },
      tableData: {},
      tableLoading: false,
      tableHead: [
        { label: '产品图片', prop: 'mainImage', slotColumn: true, slotName: 'mainImage', width: 100 },
        { label: '产品名称', prop: 'productName', slotColumn: true, slotName: 'productName', width: 150 },
        { label: '订单数量', prop: 'minNum' },
        { label: '尺寸', prop: 'size' },
        { label: '材质', prop: 'material' },
        { label: '工艺', prop: 'craft' },
        { label: '打样费', prop: 'proofingFee' },
        { label: '打样时间', prop: 'proofingTime' },
        { label: '参考价（未税）', prop: 'price' },
        { label: '大货工期', prop: 'deliveryTime' },
        // { label: '包装方式', prop: 'packingMethod' },
        { label: '供应商', prop: 'supplierName' },
        { label: '联系人', prop: 'contactName' },
        { label: '联系电话', prop: 'contactPhone' },
        { label: '间采对接人', prop: 'purchaseContactPerson' },
        { label: '更新时间', prop: 'updateDate', width: 140, type: 'time'},
      ]
    };
  },
  mounted() {
    this.$refs.CommonTable.changeHeight(80);
    this.getList();
  },
  methods: {
    goWishList () {
      this.$store.dispatch('tagsView/jumpAndClosePage', {
        open: {
          name: '心愿单',
          href: '/own-manage/wish-list',
        },
      });
      this.$router.push({
        name: 'own-manage/wish-list'
      });
    },
    getDetail (item) {
      const pageName = item.productName;
      this.$store.dispatch('tagsView/jumpAndClosePage', {
        open: {
          name: pageName,
          href: `/own-manage/own-details-page?id=${item.id}&firstCategory=${item.firstCategory}`,
          isURLSearchParams: true
        },
      });
      this.$router.push({
        name: 'own-manage/own-details-page',
        query: {
          id: item.id,
          firstCategory: item.firstCategory || ''
        },
      });
    },
    getList() {
      this.tableLoading = true;
      this.$http.pdLibrary.pdLibraryListPageMall({
        ...this.tableParam,
        data: this.searchForm
      }).then(result => {
        this.tableData = result.data;
      }).catch(err => {
        this.$message.error(err.msg);
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    pageSizeChange(pageNo, pageSize) {
      this.tableParam.pageNo = pageNo;
      this.tableParam.pageSize = pageSize;
      this.getList();
    },
    sortChange(val) {
      this.tableParam.orderBy = val;
      this.getList();
    },
    onSearch() {
      this.tableParam.pageNo = 1;
      this.getList();
    },
    changeList(obj) {
      this.searchForm = {
        ...this.searchForm,
        ...obj
      };
      this.getList();
    },
    onReset() {
      this.searchForm = {
        ...this.searchForm,
        keyWords: '',
        minPrice: '',
        maxPrice: ''
      };
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.price-box {
  display: inline-block;
  /deep/ .el-input {
    width: 100px !important;
    .el-input__inner {
      width: 100px !important;
    }
  }
  i {
    margin: 0 10px;
  }
}
.gift-search-box {
  .el-form-item {
    margin-bottom: 0px;
  }
}
.search-box {
  display: inline-block;
  margin-bottom: 10px;
  margin-top: 5px;
  .el-button--text {
    color: #333;
    font-size: 16px;
    margin-left: 20px;
    &:hover {
      color: #AB0033;
    }
  }
}
.tips-jump {
  font-size: 12px;
  font-weight: bold;
  margin-top: 5;
}
.gift-box {
  padding: 0 20px;
  margin: 0 auto;
}
/deep/ .sample-list {
  .el-tabs__item {
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
  }
  .el-tabs__nav {
    height: 30px;
  }
  #tab-jg {
    padding-left: 10px !important;
  }
  #tab-rl {
    padding-right: 10px !important;
  }
}
.search-Type {
  border: 1px solid #ddd;
  padding: 0 10px 5px 10px;
  /deep/ .el-checkbox {
    margin: 0px 8px;
  }
  /deep/ .el-radio {
    margin: 3px 15px 3px -2px;
  }
}
</style>
